import React, { useState, useEffect } from "react";
import fishBg from "../assets/delicious-red-salmon-fish-grilled-with-sauce-and-s-U5X74LH.jpg";
import promoImg1 from "../assets/box/Al-Faham-1pcsPulka-4pcsEggChettinad.jpeg";
import promoImg2 from "../assets/box/ChickenBiryaniCombo-Serves12-ComboFor12PersonNon-VegCB.jpg";
import promoImg3 from "../assets/box/TandooriChicken-1pcsTandooriRoti-2pcsEggMasal.jpeg";
import promoImg4 from "../assets/box/3pcsChickenKebabEggFriedRic.jpeg";
import promoImg5 from "../assets/box/2pcsParottaEggKeemaChicken-653pc.jpeg";

const packages = [
  {
    id: 1,
    title: "Al-Faham-1pcs + Pulka-4pcs\n+ Egg Chettinadu",
    description:
      "Enjoy our succulent Al-Faham chicken with soft pulkas and spicy egg chettinadu.",
    image: promoImg1,
    cta: "Order Now",
  },
  {
    id: 2,
    title: "Chicken Biryani Combo\n(Serves 1)",
    description:
      "Classic authentic Chicken Biryani Combo perfectly portioned for one.",
    image: promoImg2,
    cta: "Order Now",
  },
  {
    id: 3,
    title: "Tandoori Chicken-1pcs +\nTandoori Roti-2pcs + Egg Masala",
    description:
      "Freshly baked Tandoori Roti with rich Egg Masala and smoky Tandoori Chicken.",
    image: promoImg3,
    cta: "Order Now",
  },
  {
    id: 4,
    title: "3pcs Chicken Kebab +\nEgg Fried Rice",
    description:
      "Delicious egg fried rice paired perfectly with crispy, flavorful chicken kebabs.",
    image: promoImg4,
    cta: "Order Now",
  },
  {
    id: 5,
    title: "2pcs Parotta + Egg Keema\n+ Chicken-65 (3pcs)",
    description:
      "Flaky parottas served with rich egg keema and our signature Chicken-65.",
    image: promoImg5,
    cta: "Order Now",
  },
];

const SpecialPackageSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto-play
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % packages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section
      className="relative py-20 lg:py-28 bg-fixed bg-center bg-cover overflow-hidden"
      style={{
        backgroundImage: `url(${fishBg})`,
        boxShadow: "0 0 0 1px #0a1a0f",
      }}
    >
      <div className="absolute inset-0 bg-black/80"></div> {/* Dark overlay */}
      <div className="max-w-6xl mx-auto px-6 lg:px-10 relative z-10">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-['Dancing_Script'] text-[#cd3a27] font-medium leading-none">
            Special Package
          </h2>
          {/* Ornamental Divider */}
          <div className="flex items-center justify-center gap-3 mt-4">
            <div className="h-[1.5px] w-16 bg-gradient-to-r from-transparent via-[#cd3a27] to-[#cd3a27]"></div>
            <div className="w-2.5 h-2.5 border border-[#cd3a27] rotate-45 flex items-center justify-center">
              <div className="w-1 h-1 bg-[#cd3a27]"></div>
            </div>
            <div className="h-[1.5px] w-16 bg-gradient-to-l from-transparent via-[#cd3a27] to-[#cd3a27]"></div>
          </div>
        </div>

        {/* Carousel Container */}
        <div className="relative max-w-[900px] mx-auto overflow-hidden px-4 md:px-0">
          <div
            className="flex transition-transform duration-700 ease-out"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {packages.map((slide, idx) => (
              <div
                key={idx}
                className="w-full flex-shrink-0 flex flex-col md:flex-row items-stretch pb-8 pt-4"
              >
                {/* Image (Left) */}
                <div className="w-full md:w-[55%] z-10 shadow-2xl relative min-h-[250px] md:min-h-[350px]">
                  <img
                    src={slide.image}
                    alt={slide.title}
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                </div>

                {/* Offer Details (Right Overlapping) */}
                <div className="w-[90%] mx-auto md:mx-0 md:w-[45%] bg-white p-8 md:p-12 md:-ml-8 z-20 shadow-[-10px_0_30px_rgba(0,0,0,0.3)] flex flex-col justify-center transform -translate-y-8 md:translate-y-0 my-auto">
                  <h3 className="text-[1.25rem] font-bold text-[#111] leading-snug mb-5 whitespace-pre-line">
                    {slide.title}
                  </h3>
                  <p className="text-gray-500 text-[13px] leading-relaxed mb-10 max-w-[90%]">
                    {slide.description}
                  </p>
                  <div className="mt-auto">
                    <button className="border border-[#cd3a27] text-[#cd3a27] text-[10px] tracking-[0.2em] uppercase font-bold px-8 py-3.5 hover:bg-[#cd3a27] hover:text-white transition-all duration-300">
                      {slide.cta}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Paginator Dots */}
        <div className="flex justify-center items-center gap-3 mt-4">
          {packages.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentSlide(idx)}
              className={`w-2 h-2 rounded-[2px] rotate-45 transition-all duration-300 ${
                idx === currentSlide
                  ? "bg-[#cd3a27] scale-150"
                  : "bg-white/40 hover:bg-white/80"
              }`}
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default SpecialPackageSection;
